import { makeAutoObservable } from "mobx";
import { ISearchField, SEARCH_PRODUCT_BY_FIELDS } from "../models/User";

type SearchByMap = {
    [key in SEARCH_PRODUCT_BY_FIELDS]?: boolean
}

class SearchByStore {

    private _model: SearchByMap = {};
    private _change: SearchByMap = {}; 

    constructor(model: ISearchField[]){
        makeAutoObservable(this, {}, { autoBind: true });

        this.setModel(model || []);
        this.discardChanges();
    }

    private setModel(model: ISearchField[]) {
        model.forEach(m => {
            this._model[m.search_by_field as SEARCH_PRODUCT_BY_FIELDS] = true;
        });
    }

    public hasChanges() {
        return JSON.stringify(this._change) !== JSON.stringify(this._model);
    }

    public getUpdatedModel(): ISearchField[] {
        return this.searchProductBy.map(v => ({search_by_field: v})); // shape the values for the return value
    }

    public discardChanges(): void {
        this._change = JSON.parse(JSON.stringify(this._model));
    }

    public get searchProductBy(): SEARCH_PRODUCT_BY_FIELDS[] {
        return Object.entries(this._change) // get the change in an array form ((k, v), (k1, v1), ...)
            .filter((v) => v[1]) // filter only the values that are true
            .map(v => v[0] as SEARCH_PRODUCT_BY_FIELDS);
    }

    public getValue(v: SEARCH_PRODUCT_BY_FIELDS){
        return this._change[v];
    }

    public get isValid(): boolean {
        // at least one `true`
        return Object.values(this._change).filter(v => v).length > 0;
    }

    public setValue(field: SEARCH_PRODUCT_BY_FIELDS, v: boolean) {
        this._change[field] = v;
    }
}

export default SearchByStore;